import React, { PropsWithChildren } from 'react';
import { AppBar, Box, Container, Toolbar } from '@material-ui/core';
import MainMenuButton from '@components/app.chrome/main.menu.button';
import GameMenuButton from '@components/app.chrome/game.menu.button';
import UserMenuButton from '@components/app.chrome/user.menu.button';
import { AppBarTitle } from './app.chrome.styles';

interface AppChromeProps {
  pageTitle?: string;
}

const AppChrome = ({ pageTitle = '', children }: PropsWithChildren<AppChromeProps>) => {
  return (
    <>
      <AppBar position='sticky'>
        <Toolbar>
          <MainMenuButton />

          <AppBarTitle variant='h6'>
            <GameMenuButton />
            {pageTitle || 'Admin'}
          </AppBarTitle>

          <UserMenuButton />
        </Toolbar>
      </AppBar>

      <Container>
        <Box mt={2} mb={2}>
          {children}
        </Box>
      </Container>
    </>
  );
};

export default AppChrome;
